<template>
  <div>
    <header class="searchHeader coupons">
        <div class="found" v-if="geolocation">
            <p class="count"><span class="num">{{ total }}</span>件</p>
        </div>
        <div class="filters" v-if="geolocation">
            <form class="actions">
                <div class="icon"></div>
                <!-- <div class="chip selectable genre column" :class="{ 'selected': filters.genre.length !== 0 }"
                    @click.self="togglePopup('genre')">
                    絞り込み
                    <div class="popup" v-if="popup === 'genre'" v-click-outside="onClickOutside" @click.self="togglePopup('genre')">
                        <div class="content">
                            <h2 class="title"> 絞り込み </h2>
                            <label v-for="(genre, i) in genres" :key="i">
                                <input type="checkbox" name="genre" v-model="filters.genre" :value="genre.id">
                                {{ genre.name }}
                            </label>
                            <div class="button" @click="togglePopup('genre')"> 適用する </div>
                        </div>
                    </div>
                </div> -->
                <div class="chip selectable categories column" :class="{ 'selected': filters.other.length !== 0 }"
                    @click.self="togglePopup('other')">
                    店舗カテゴリ
                    <div class="popup" v-if="popup === 'other'" @click.self="togglePopup('other')">
                        <div class="content" v-click-outside="onClickOutside">
                            <h2 class="title"> 店舗カテゴリ </h2>
                            <label v-for="(category, i) in categories" :key="i">
                                <input type="checkbox" name="other" v-model="filters.other" :value="category.id">
                                {{ category.name }}
                            </label>
                            <div class="button" @click="togglePopup('other')"> 適用する </div>
                        </div>
                    </div>
                </div>
                <div class="clear" @click.stop="clear()">クリア</div>
            </form>
        </div>
      </header>
      <section>
        <template v-if="!geolocation">
            位置情報サービスが使用できません
        </template>
        <template v-else-if="geolocationPositionError !=null">
            位置情報が取得できませんでした
        </template>
        <template v-else-if="geolocationPosition == null">
            位置情報取得中
        </template>
        <template v-else-if="couponsError != null">
            クーポンの取得中にエラーが発生しました
        </template>
        <template v-else-if="filteredCoupons == null">
            近くの店舗のクーポンを取得中
        </template>
        <template v-else-if="!filteredCoupons.length">
            クーポンが見つかりませんでした
        </template>
        <ul class="couponsList" v-else>
          <li v-for="(coupon) in filteredCoupons" :key="coupon.coupon.id">
                <!-- <ul class="labels">
                    <li>
                        ハッピーアワー
                    </li>
                    <li class="inverted">
                        セール実施中
                    </li>
                </ul> -->
            <like-button
                :id="coupon.coupon.id"
                :liked="coupon.coupon.like_flag"
                :like-count="coupon.coupon.liked"
                :content-type="5"
                :auth="auth">
            </like-button>
            <div class="img lazyload" :data-bg="imageStyle(coupon.coupon.image_url)">
              <a :href="coupon.shop.url">
                <div class="content">
                    <div v-if="coupon.shop.category.name_public" class="genre">
                        {{ coupon.shop.category.name_public}}
                    </div>
                    <div class="title">
                        {{ coupon.shop.name_ja }}
                    </div>
                </div>
              </a>
            </div>
            <div class="text">
              <div class="date">
                <div><span>{{ coupon.coupon.expiration_end_date }}</span>まで有効</div>
                <a @click="
                  selectedCouponId = coupon.coupon.id,
                  isDetail = true"
                  href="javascript:void(0)" class="detail detailCouponButton"
                >
                  詳細
                </a>
              </div>
              <div class="title">
                {{ coupon.coupon.title }}
              </div>
              <div class="button useCouponButton" @click="
                selectedCouponId = coupon.coupon.id,
                isDetail = false
              ">
                クーポンを使う
              </div>
            </div>
          </li>
        </ul>
    </section>
    <Transition name="couponView" @before-enter="beforeEnter" @after-leave="afterLeave">
      <div class="couponView" v-if="selectedCoupon" @click.self="closeCouponView">
        <div class="box" v-if="isDetail">
          <div class="header">
            <div class="headerBox">
              <div class="headerTitle">
                クーポン詳細
              </div>
            </div>
            <div class="close" @click="closeCouponView"></div>
          </div>
          <div class="img detail lazyload" :data-bg="imageStyle(selectedCoupon.coupon.image_url)">
            <div class="meta">
              <div class="genre" v-if="selectedCoupon.shop.category.name_public">
                {{ selectedCoupon.shop.category.name_public  }}
              </div>
              <div class="title dashed">
                {{ selectedCoupon.shop.name }} / {{ selectedCoupon.shop.name_ja }}
              </div>
            </div>
          </div>
          <ul class="textDetail">
            <li v-if="selectedCoupon.coupon.overview" class="textDetail-content">
              <div class="textDetail-content-title">内容</div>
              <p class="description">
                {{ selectedCoupon.coupon.overview }}
              </p>
            </li>
            <li class="textDetail-content">
              <div class="textDetail-content-title">有効期限</div>
              <p class="description">
                {{ selectedCoupon.coupon.expiration_end_date_en }}
              </p>
            </li>
            <li v-if="selectedCoupon.coupon.use_condition" class="textDetail-content">
              <div class="textDetail-content-title">利用条件</div>
              <p class="description">
                {{ selectedCoupon.coupon.use_condition }}
              </p>
            </li>
            <div class="detailMore-button-container">
              <a class="button more" :href="selectedCoupon.shop.url">
                店舗情報をみる
              </a>
              <a @click="isDetail = false" class="button use" href="javascript:void(0)">
                クーポンを使う
              </a>
            </div>
          </ul>
        </div>
        <div class="box" v-if="!isDetail">
          <div class="header">
            <div class="headerBox">
              <div class="headerTitle">
                <img src="/assets/img/common/logo.svg" alt="ALOCO" class="logo"> Coupon
              </div>
              <span>Powered by Made in Hawaii TV</span>
            </div>
            <div class="close" @click="closeCouponView"></div>
          </div>
          <div class="img lazyload" :data-bg="imageStyle(selectedCoupon.coupon.image_url)">
            <div class="content">
              <div class="title">この画面をスタッフにご提示ください</div>
              <div class="subTitle">
                please present this coupon<br>
                when you order / purchase / check-in.
              </div>
            </div>
          </div>
          <div class="text">
            <div class="genre" v-if="selectedCoupon.shop.category.name_public">
              {{ selectedCoupon.shop.category.name_public  }}
            </div>
            <div class="title dashed">
              {{ selectedCoupon.shop.name }} / {{ selectedCoupon.shop.name_ja }}
            </div>
            <div class="title">
              {{ selectedCoupon.coupon.title }}
            </div>
            <p class="description" v-if="selectedCoupon.coupon.overview">
              {{ selectedCoupon.coupon.overview }}
            </p>
            <dl class="couponDetailList">
              <template v-if="selectedCoupon.coupon.use_condition">
                <dt>
                  利用条件 / Conditions
                </dt>
                <dd>
                  {{ selectedCoupon.coupon.use_condition }}
                </dd>
              </template>
              <dt>
                有効期限 / Expires
              </dt>
              <dd>
                {{ selectedCoupon.coupon.expiration_end_date }}
              </dd>
            </dl>
            <div class="useCoupon-button-container">
              <audio class="audio" ref="audioElement" controls>
                <source src="/audio/useCoupon.mp3" type="audio/mpeg">
              </audio>
              <button @click="playAudio()" class="button use">
                <div>
                  <span class="en">Can I use this coupon?</span>
                  <span class="ja">このクーポンは使えますか？</span>
                </div>
              </button>
              <p>ボタンをタップすると、音声が流れます</p>
            </div>
          </div>
        </div>
      </div>
    </Transition>
  </div>
</template>
<script>
import axios from 'axios';
import vClickOutside from 'click-outside-vue3'

const categories = [
  {name: 'グルメ', id: '0'},
  {name: 'ホテル', id: '1'},
  {name: 'ショッピング', id: '2'},
  {name: 'ツアー・アクティビティ', id: '3'},
  {name: 'レンタル・サービス', id: '4'},
  {name: 'ビューティー', id: '5'},
]

export default {
    props: {
        auth: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
          geolocationAvailable: null,
          geolocationPosition: null,
          geolocationPositionError: null,
          couponsError: null,
          coupons: null,
          selectedCouponId: null,
          filters: {
              sortBy: null,
              genre: [],
              other: [],
              area: null
          },
          popup: null,
          isDetail: false,
        }
    },
    created() {
      if(!this.showFlag) return;
      if(!this.geolocation) return;
      this.geolocation.getCurrentPosition(
        (geo) => {
          this.geolocationPosition = geo;
          this.getCoupons();
        },
        (error) => {
          this.geolocationPositionError = error;
        },
        {
          enableHighAccuracy: true,
        }
      );
    },
    directives: {
        clickOutside: vClickOutside.directive
    },
    computed: {
      categories(){
        return categories;
      },
      geolocation(){
        return navigator.geolocation;
      },
      total(){
        return this.coupons ? this.coupons.length : '-';
      },
      filteredCoupons(){
        if(this.coupons == null) return null;
        if(!this.filters.other.length) return this.coupons;
        const cats = this.filters.other.map(index=>this.categories[index]);
        const names = cats.map((cat)=>cat.name);
        const found = this.coupons.filter((coupon)=>names.includes(coupon.shop.category.parent_category_name_public))
        return found;
      },
      selectedCoupon(){
        if(!this.selectedCouponId) return null;
        if(!this.coupons) return null;
        return this.coupons.find((coupon)=>coupon.coupon.id===this.selectedCouponId);
      },
      coordinates(){
        const queryString = window.location.search;
        const urlSearchParams = new URLSearchParams(queryString);
        const [latParam, lonParam] = [urlSearchParams.get('lat'), urlSearchParams.get('lon')]
        const range = [urlSearchParams.get('range')]
        const [latitude, longitude] = (latParam !=null && lonParam !=null)
          ? [latParam, lonParam]
          : [this.geolocationPosition.coords.latitude, this.geolocationPosition.coords.longitude]
        return [latitude, longitude, range]
      },
      showFlag(){
        const url = new URL(window.location.href)
        const searchParams = url.searchParams
        if (searchParams.has('type')) {
          const type = searchParams.get('type')
          return (type === 'nearby') ? true : false
        }
      }
    },
    mounted() {
      this.lazyLoad();
    },
    methods: {
        lazyLoad() {
          document.addEventListener('lazybeforeunveil', function(e) {
            let bg = e.target.getAttribute('data-bg');
            if (bg){
              e.target.style.backgroundImage = `url("${bg}")`;
            }
          });
        },
        imageStyle(url) {
          return url ?? null;
        },
        async getCoupons(){
          try {
            const [latitude, longitude, range] = this.coordinates;
            const response = await axios.get(`/coupon/list?lat=${latitude}&lon=${longitude}&range=${range}`);
            this.coupons = response.data;
          } catch(e) {
            this.couponsError = e;
          }
        },
        onClickOutside() {
            this.popup = this.popup = null
        },
        togglePopup(filter) {
            this.popup = this.popup === filter ? null : filter
        },
        clear() {
            this.filters = {
                sort_by: null,
                genre: [],
                other: [],
                area: null
            }
        },
        closeCouponView() {
          this.selectedCouponId = null;
        },
        beforeEnter() {
          // .couponViewが表示される前にbodyのoverflowをhiddenにし、スクロールできないようにする
          document.body.style.overflow = "hidden";
        },
        afterLeave() {
          // .couponViewが非表示になった後にbodyのoverflowを削除する
          document.body.style.overflow = "";
        },
        playAudio() {
          const audioElement = this.$refs.audioElement
          audioElement.play()
        }
    },
}
</script>
